import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

//Import Components
import VerticalLayout from "./VerticalLayouts/index";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";

//import logo
const logoSm = require("../resources/images/mcLogoCircle.svg");
const logoDark = require("../resources/images/mcLogo_woCircle.svg");
const logoLight = require("../resources/images/mcLogoW_woCircle.svg");

const Sidebar = ({ layoutType }) => {

    useEffect(() => {
        const verticalOverlay = document.getElementsByClassName("vertical-overlay");

        const handleClick = () => {
            document.body.classList.remove("vertical-sidebar-enable");
        };

        if (verticalOverlay?.[0]) {
            verticalOverlay[0].addEventListener("click", handleClick);
        }

        return () => {
            if (verticalOverlay?.[0]) {
                verticalOverlay[0].removeEventListener("click", handleClick);
            }
        };
    }, []);

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm.default} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark.default} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm.default} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLight.default} alt="" height="17" />
            </span>
          </Link>
          {/*<button*/}
          {/*  onClick={addEventListenerOnSmHoverMenu}*/}
          {/*  type="button"*/}
          {/*  className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"*/}
          {/*  id="vertical-hover"*/}
          {/*>*/}
          {/*  <i className="ri-record-circle-line"/>*/}
          {/*</button>*/}
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"/>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
         <TwoColumnLayout layoutType={layoutType} />
        ) : (
          <SimpleBar id="scrollbar" className="h-100">
            <Container fluid>
              <div id="two-column-menu"/>
              <ul className="navbar-nav" id="navbar-nav">
                <VerticalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </SimpleBar>
        )}
      <div className="sidebar-background"/>
      </div>
      <div className="vertical-overlay"/>
    </React.Fragment>
  );
};

export default Sidebar;
